import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { networkRequest } from '@tencent/ark-request';
import humps from 'humps';
import { getXsrfToken } from "../cgi/cookies";
import { wait } from "../common/wait";
import { Backend } from "../types/backend";
export function fetchPreviewInfo(_x) {
  return _fetchPreviewInfo.apply(this, arguments);
}
function _fetchPreviewInfo() {
  _fetchPreviewInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(req) {
    var fileId, password, retry, objKey, shouldRetry, send, tryDuration, tryCount, rsp;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          fileId = req.fileId, password = req.password, retry = req.retry, objKey = req.objKey;
          shouldRetry = retry || false;
          send = function send() {
            var request = networkRequest.request({
              url: "/v2/drive/preview/query?xsrf=".concat(getXsrfToken()),
              method: 'POST',
              data: {
                file_id: fileId,
                obj_key: objKey,
                password: password,
                should_retry: shouldRetry
              }
            });
            shouldRetry && (shouldRetry = false);
            return request;
          };
          tryDuration = 1000;
          tryCount = 60;
          _context.next = 7;
          return send();
        case 7:
          rsp = _context.sent;
        case 8:
          if (!(tryCount -= 1)) {
            _context.next = 20;
            break;
          }
          if (!(rsp.data.retcode === Backend.RetCode.NOT_FINISH)) {
            _context.next = 17;
            break;
          }
          _context.next = 12;
          return wait(tryDuration);
        case 12:
          _context.next = 14;
          return send();
        case 14:
          rsp = _context.sent;
          _context.next = 18;
          break;
        case 17:
          return _context.abrupt("break", 20);
        case 18:
          _context.next = 8;
          break;
        case 20:
          return _context.abrupt("return", humps.camelizeKeys(rsp.data));
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchPreviewInfo.apply(this, arguments);
}
//# sourceMappingURL=query.js.map